var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.7072C1 16.0287 5.3143 20.343 10.6359 20.343C15.9574 20.343 20.2717 16.0287 20.2717 10.7072C20.2717 5.38516 15.9574 1.07129 10.6359 1.07129C5.3143 1.07129 1 5.38516 1 10.7072Z",
    fill: "url(#paint0_linear_2709_1622)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4946 18.201C14.6337 18.201 17.9891 14.8456 17.9891 10.7065C17.9891 6.56734 14.6337 3.21191 10.4946 3.21191C6.35543 3.21191 3 6.56734 3 10.7065C3 14.8456 6.35543 18.201 10.4946 18.201ZM11.619 7.70865C11.8644 8.03546 12.0403 8.41752 12.1246 8.83284H13.4924V9.95702H12.1246C11.8642 11.2399 10.73 12.2054 9.37038 12.2054H9.22851L12.0162 14.9931L11.2213 15.788L7.49674 12.0635V11.0812H9.37038C10.1046 11.0812 10.7292 10.612 10.9607 9.95702H7.49674V8.83284H10.9607C10.7292 8.1779 10.1046 7.70865 9.37038 7.70865H7.49674V6.58447H13.4924V7.70865H11.619Z",
    fill: "#F5A50B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2709_1622",
    x1: 10.6359,
    y1: 1.07129,
    x2: 10.6359,
    y2: 20.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5437E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIconSvg);
export default __webpack_public_path__ + "static/media/rewardIconSvg.b84da15c88c6e6847ad8320df90aaf03.svg";
export { ForwardRef as ReactComponent };